import * as React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { GlobalStyles } from '../lib/GlobalStyles'
import { PDFToolsTheme } from '../lib/theme'
import { PageHeader } from '../modules/PageHeader/PageHeader'
import { ThemeName } from '../lib/constants'
import { PageFooter } from '../modules/PageFooter/PageFooter'


export const DefaultLayout = ({
  children,
  subNavigation,
  theme = 'azure'
}: {
  children: React.ReactNode
  subNavigation?: JSX.Element
  theme?: ThemeName
}) => {
  return (
    <div className={theme}>
      <ThemeProvider theme={PDFToolsTheme}>
        <GlobalStyles />
        <PageHeader subNavigation={subNavigation} />
        <main>{children}</main>
        <PageFooter />
      </ThemeProvider>
    </div>
  )
}
